module.exports = __webpack_public_path__ + "img/slide2.c30ed0db.jpg";